import React, { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  url?: string;
}

export const SEO: React.FC<SEOProps> = ({ title, description, url = 'https://parentscheck.com' }) => {
  useEffect(() => {
    // Update Title
    document.title = title;

    // Update Meta Tags
    const updateMeta = (name: string, content: string) => {
      let element = document.querySelector(`meta[name="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('name', name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    const updateOg = (property: string, content: string) => {
      let element = document.querySelector(`meta[property="${property}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('property', property);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    updateMeta('description', description);
    updateOg('og:title', title);
    updateOg('og:description', description);
    updateOg('og:url', url);
  }, [title, description, url]);

  return null;
};
